// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__WO0lL","item":"Dropdown_item__p14Wo"};